import VueRouter from 'vue-router'
import Home from '@/js/views/Home.vue'

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        auth: undefined
      }
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: () => import('@/js/views/Mobile.vue'),
      meta: {
        auth: undefined
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/js/views/Login.vue'),
      meta: {
        auth: false
      }
    },
    {
      path: '/password/forgot',
      name: 'forgotPassword',
      component: () => import('@/js/views/ForgotPassword.vue'),
      meta: {
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'resetPassword',
      component: () => import('@/js/views/ResetPassword.vue'),
      meta: {
        auth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/js/views/Register.vue'),
      meta: {
        auth: false
      }
    },
    {
      path: '/email/verify/:token',
      name: 'verifyEmail',
      component: () => import('@/js/views/VerifyEmail.vue'),
      meta: {
        auth: false
      }
    },
    {
      path: '/house/join/:token',
      name: 'joinHouse',
      component: () => import('@/js/views/JoinHouse.vue'),
      meta: {
        auth: undefined
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/js/views/Dashboard.vue'),
      children: [
        {
          path: 'account',
          name: 'account'
        },
        {
          path: 'eat',
          name: 'eat'
        },
        {
          path: 'costs',
          name: 'costs'
        },
        {
          path: 'statistics',
          name: 'statistics'
        },
        {
          path: 'items',
          name: 'items'
        },
        {
          path: 'house',
          name: 'house'
        },
        {
          path: 'settings',
          name: 'settings'
        }
      ],
      meta: {
        auth: true
      }
    },
    // Redirect to home page if resource is not found
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// export default router
